export enum WebFormThemeTemplateEnum {
  Standard = 'default',
  DarkSeaGreen = 'darkseagreen',
  DarkRed = 'darkred',
  Purple = 'purple',
}
